import { Tooltip } from "@mui/material";
import { Link } from "react-router-dom";
import {
  DeviceConnectedLogo,
  DeviceDisconnectedLogo,
} from "../../../../Logo/logos";
import { BatteryIcon } from "../../../../icons/StatusIcons";

const LevelDevice = ({
  title,
  deviceId,
  deviceStatus,
  levelValue,
  lastUpdatedDate,
  lastUpdatedTime,
  powerStatus,
}) => {
  // Check if this is an expired subscription message
  const isExpiredSubscription = levelValue === "Subscription Expired";

  return (
    <div
      style={{
        backgroundImage: "url(/images/level-static.png)",
      }}
      className="device-card-level"
    >
      <div className="device-card-head">
        <Tooltip title={title || ""} placement="top">
          <Link to={`/device-detail/${deviceId}`} style={{ textDecoration: "none" }}>
            <div className="device-card-title">
              {title}
            </div>
          </Link>
        </Tooltip>
        <div className="device-card-status">
          <>
            {!isExpiredSubscription && (
              deviceStatus === "active" ? (
                <Tooltip title="Device Connected">
                  <DeviceConnectedLogo />
                </Tooltip>
              ) : (
                <Tooltip title="Device Disconnected">
                  <DeviceDisconnectedLogo />
                </Tooltip>
              )
            )}
            {!isExpiredSubscription && (
              <Tooltip title={powerStatus === 1 ? "Power On" : "Power Off"}>
                <BatteryIcon on={powerStatus === 1} />
              </Tooltip>
            )}
          </>
        </div>
      </div>
      <div className="device-card-metrics">
        {isExpiredSubscription ? (
          <div className="device-card-expired">
            {levelValue}
          </div>
        ) : (
          <>
            <div className="device-card-metric">
              <div className="device-card-metric-label">Level</div>
              <div className="device-card-metric-value device-card-metric-stamp">
                {levelValue}
              </div>
            </div>
            <div className="device-card-metric">
              <div className="device-card-metric-label">Last Updated</div>
              <div className="device-card-metric-value device-card-metric-stamp">
                {lastUpdatedDate || "--"}
              </div>
              <div className="device-card-metric-value device-card-metric-stamp">
                {lastUpdatedTime || "--"}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default LevelDevice;
